import { useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { Textarea } from '@/components/ui/Textarea';
import type { Referral } from '@/types/referral.types';

interface RejectReferralModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
  isLoading: boolean;
  referral: Referral | null;
}

export default function RejectReferralModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  referral,
}: RejectReferralModalProps) {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!reason.trim()) {
      setError('Informe o motivo da rejeicao');
      return;
    }

    await onConfirm(reason);
    setReason('');
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  if (!referral) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Rejeitar Indicacao"
      size="md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800">
          <p className="text-sm text-yellow-800 dark:text-yellow-300">
            Voce esta prestes a rejeitar a indicacao de{' '}
            <strong>{referral.referrerName || referral.referrerPhone}</strong> para{' '}
            <strong>{referral.refereeName || referral.refereePhone}</strong>.
          </p>
        </div>

        <Textarea
          label="Motivo da rejeicao *"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ex: Usuario indicado ja existia no sistema antes da indicacao..."
          rows={4}
          error={error}
        />

        <div className="flex justify-end gap-2 pt-4">
          <Button variant="ghost" type="button" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="danger"
            isLoading={isLoading}
          >
            Rejeitar
          </Button>
        </div>
      </form>
    </Modal>
  );
}
